import { useState, useEffect } from 'react';
import { Grid, Autocomplete } from '@mui/material'
import { Formik, Form, useFormik } from 'formik';
import * as S from './style'
import * as Yup from "yup";
import ButtonCustom from 'components/ButtonCustom/ButtonCustom';
import showToast from 'components/Toast/Toast';
import { getClients, createLeadRelation, getChildLeads, getParentLeads } from 'utils/requests/leads';

const LinkSubLead = ({ leadInfo, refetch, closeModal }) => {
  const [validateFields, setValidateFields] = useState(false);
  const [leads, setLeads] = useState([]);
  const [linkedSubLeads, setLinkedSubLeads] = useState([]);
  const [parentLeads, setParentLeads] = useState([]);

  useEffect(() => {
    const fetchLinkedSubLeads = async () => {
      try {
        if (leadInfo?.lead?.id) {
          const childLeadsData = await getChildLeads(leadInfo.lead.id);
          if (childLeadsData && !childLeadsData.message) {
            setLinkedSubLeads(childLeadsData);
          }
        }
      } catch (error) {
        console.error('Erro ao buscar SubLeads vinculados:', error);
        setLinkedSubLeads([]);
      }
    };
    fetchLinkedSubLeads();
  }, [leadInfo?.lead?.id]);

  useEffect(() => {
    const fetchParentLeads = async () => {
      try {
        if (leadInfo?.lead?.id) {
          const parentLeadsData = await getParentLeads(leadInfo.lead.id);
          if (parentLeadsData && !parentLeadsData.message) {
            setParentLeads(parentLeadsData);
          }
        }
      } catch (error) {
        console.error('Erro ao buscar Leads pai:', error);
        setParentLeads([]);
      }
    };
    fetchParentLeads();
  }, [leadInfo?.lead?.id]);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response = await getClients();
        if (response && !response.message && response[0]) {
          let filteredLeads = response[0].filter(lead => lead.id !== leadInfo?.lead?.id);
          
          if (linkedSubLeads.length > 0) {
            const linkedSubLeadIds = linkedSubLeads.map(relation => relation.childLead.id);
            filteredLeads = filteredLeads.filter(lead => !linkedSubLeadIds.includes(lead.id));
          }
          
          if (parentLeads.length > 0) {
            const parentLeadIds = parentLeads.map(relation => relation.parentLead.id);
            filteredLeads = filteredLeads.filter(lead => !parentLeadIds.includes(lead.id));
          }
          
          setLeads(filteredLeads);
        } else {
          setLeads([]);
        }
      } catch (error) {
        console.error('Erro ao buscar leads:', error);
        setLeads([]);
      }
    };
    fetchLeads();
  }, [leadInfo?.lead?.id, linkedSubLeads, parentLeads]);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: validateFields,
    validateOnBlur: false,

    initialValues: {
      childLead: '',
    },
    validationSchema: Yup.object({
      childLead: Yup.string().required('Marca é obrigatório'),
    }),
    onSubmit: async (values) => {
      const relationValues = {
        parentLead: leadInfo?.lead?.id,
        childLead: values.childLead
      };

      if (relationValues.parentLead && relationValues.childLead) {
        await createLeadRelation(relationValues).then((res) => {
          if (res?.message || res?.error) {
            showToast('Falha ao vincular Marca', 'error');
          } else {
            showToast('Marca vinculada com sucesso!', 'success');
            refetch();
            closeModal();
          }
        }).catch((error) => {
          console.error('Erro ao criar relação:', error);
          showToast('Erro ao vincular Marca', 'error');
        });
      } else {
        showToast('Dados inválidos para criar a relação', 'error');
      }
    }
  });

  return (
    <Grid container flexDirection='column' data-cy="link-sublead-modal">
      <p>Vincular Marca</p>
      <Formik initialValues={formik.initialValues} validationSchema={formik.validationSchema} onSubmit={formik.handleSubmit}>
        <Form>
          <Grid container flexDirection='column' gap='15px' mt='20px'>
            <Grid container justifyContent='space-between'>
              <S.InputGrid item xs={12} md={12} xl={12}>
                <Autocomplete
                  limitTags={10}
                  name='childLead'
                  value={formik.values.childLead ? leads.find(lead => lead.id === formik.values.childLead) || null : null}
                  onChange={(e, value) => {
                    formik.setFieldTouched('childLead')
                    formik.setFieldValue('childLead', value ? value.id : '')
                  }}
                  options={Array.isArray(leads) ? leads : []}
                  sx={{ width: "100%" }}
                  getOptionLabel={(option) => option.businessName || ''}
                  slotProps={{
                    popper: {
                      sx: {
                        '& .MuiAutocomplete-paper': {
                          backgroundColor: '#0E0E0E',
                          color: '#ffffff',
                          border: '1px solid #333',
                        },
                        '& .MuiAutocomplete-option': {
                          color: '#ffffff',
                          '&:hover': {
                            backgroundColor: '#333',
                          },
                          '&[aria-selected="true"]': {
                            backgroundColor: '#444',
                          }
                        }
                      }
                    }
                  }}
                  renderInput={(params) =>
                    <S.Input
                      {...params}
                      placeholder='Empresa'
                      error={Boolean(formik.errors.childLead)}
                      helperText={formik.errors.childLead}
                    />
                  }
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
              </S.InputGrid>
            </Grid>
          </Grid>
          <Grid container justifyContent='flex-end' mt='15px'>
            <ButtonCustom
              label='Vincular'
              type='submit'
              sx={{ width: "150px", height: "40px !important", fontSize: "18px", fontWeight: "500" }}
              onClick={() => setValidateFields(true)}
            />
          </Grid>
        </Form>
      </Formik>
    </Grid>
  )
}

export default LinkSubLead